import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';

const ButtonChangeSort = () => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <div
      style={{
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: systemConfiguration.primary_color
      }}
    ></div>
  );
};
export const SorterChat = (props) => {
  const { sort } = useQueueContentChatContext();
  return (
    <Dropdown
      isOpen={props.openDropDown}
      toggle={props.toggle}
      direction="end"
      nav
    >
      {props.children}
      <DropdownMenu>
        <DropdownItem header>Organizar por</DropdownItem>
        <DropdownItem
          onClick={(e) => {
            e.preventDefault();
            props.handlerSort('MORE_TIME_IN_QUEUE');
            e.stopPropagation();
          }}
          style={{
            display: 'flex'
          }}
        >
          Maior tempo em atendimento
          {sort['MORE_TIME_IN_QUEUE'] && <ButtonChangeSort />}
        </DropdownItem>
        <DropdownItem
          style={{
            display: 'flex'
          }}
          onClick={(e) => {
            e.preventDefault();
            props.handlerSort('LAST_MESSAGE_CUSTOMER');
            e.stopPropagation();
          }}
        >
          Última mensagem recebida
          {sort['LAST_MESSAGE_CUSTOMER'] && <ButtonChangeSort />}
        </DropdownItem>
        <DropdownItem
          style={{
            display: 'flex'
          }}
          onClick={(e) => {
            e.preventDefault();
            props.handlerSort('MORE_TIME_IN_WAIT');
            e.stopPropagation();
          }}
        >
          Maior tempo em espera
          {sort['MORE_TIME_IN_WAIT'] && <ButtonChangeSort />}
        </DropdownItem>
        <DropdownItem
          style={{
            display: 'flex'
          }}
          onClick={(e) => {
            e.preventDefault();
            props.handlerSort('CHATS_SAVED');
            e.stopPropagation();
          }}
        >
          Conversas sinalizadas
          {sort['CHATS_SAVED'] && <ButtonChangeSort />}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
